<template>
  <div id="app">
    <AuthPage />
  </div>
</template>

<script>
import AuthPage from '@/views/AuthPage.vue';

export default {
  name: 'App',
  components: { AuthPage }
};
</script>

<style lang="less">
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
}

#app {
  font-family: 'Qanelas-Soft', Helvetica, Arial, sans-serif;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
</style>
